<template>
	<div class="form-container">
		<h3 class="vrnu-headline">{{ formData }}</h3>
		<b-form v-on:submit.prevent="save">
			<b-container class="no-padding">
				<b-row>
					<b-col>
						<b-form-group
							label="Vorname"
							label-for="firstname">
							<b-form-input id="firstname"
								type="text"
								placeholder="Vorname"
								v-model.trim="user.firstname"
								v-validate="'required'"
								data-vv-name="Vorname"
								:class="{'has-error': errors.has('Vorname')}">
							</b-form-input>
							<p v-if="errors.has('Vorname')" class="error-message">
								{{ errors.first('Vorname') }}
						    </p>
						</b-form-group>
						<b-form-group
							label="Nachname"
							label-for="lastname">
							<b-form-input id="lastname"
								type="text"
								placeholder="Nachname"
								v-model.trim="user.lastname"
								v-validate="'required'"
								data-vv-name="Nachname"
								:class="{'has-error': errors.has('Nachname')}">
							</b-form-input>
							<p v-if="errors.has('Nachname')" class="error-message">
								{{ errors.first('Nachname') }}
						    </p>
						</b-form-group>
						<b-form-group
							label="eMail"
							label-for="email">
							<b-form-input id="email"
								type="text"
								placeholder="eMail"
								v-model.trim="user.email"
								v-validate="'required|email|checkIfUserEmailExists:' + userEmail"
								data-vv-name="eMail"
								:class="{'has-error': errors.has('eMail')}">
							</b-form-input>
							<p v-if="errors.has('eMail')" class="error-message">
								{{ errors.first('eMail') }}
						    </p>
						</b-form-group>
						<div v-if="!isUpdate">
							<b-form-group
								label="Passwort"
								label-for="password">
								<b-form-input id="password"
									type="password"
									placeholder="Passwort"
									v-model.trim="user.password"
									v-validate="'required|checkPasswordForValidity'"
									data-vv-name="Passwort"
									:class="{'has-error': errors.has('Passwort')}">
								</b-form-input>
								<p v-if="errors.has('Passwort')" class="error-message">
									{{ errors.first('Passwort') }}
							    </p>
							</b-form-group>
						</div>
						<div v-else>
							<b-form-group
								label="Passwort ändern"
								label-for="changePassword">
								<b-form-checkbox id="changePassword"
							                     v-model.trim="changePassword"
							                     v-bind:value="true"
							                     v-bind:unchecked-value="false">
							      Passwort ändern
							    </b-form-checkbox>
							</b-form-group>			
							<b-form-group
								v-if="changePassword"
								label="Passwort"
								label-for="password">
								<b-form-input id="password"
									type="password"
									placeholder="Passwort"
									v-model.trim="user.password"
									v-validate="'required|checkPasswordForValidity'"
									data-vv-name="Passwort"
									:class="{'has-error': errors.has('Passwort')}">
								</b-form-input>
								<p v-if="errors.has('Passwort')" class="error-message">
									{{ errors.first('Passwort') }}
							    </p>
							</b-form-group>
						</div>
						<b-form-group
							label="Rolle"
							v-bind:description="explanation[user.role]"
							label-for="role">
							<b-form-select 	if="role"
											v-model.trim="user.role"
											v-bind:options="options"
											class="mb-3" />
						    </b-form-checkbox>
						</b-form-group>
						<b-form-group
							label="Aktiv"
							label-for="active">
							<b-form-checkbox id="active"
						                     v-model.trim="user.active"
						                     v-bind:value="true"
						                     v-bind:unchecked-value="false">
						      Der Benutzer ist aktiv und darf sich einloggen
						    </b-form-checkbox>
						</b-form-group>
						<!-- {{ explanation[user.role] }} -->
						<div class="space20"></div>
					</b-col>
				</b-row>
			</b-container>
			<b-button type="submit" class="vrnu-button" variant="primary">Speichern</b-button>
			<b-button type="reset" variant="secondary">Zurücksetzen</b-button>
		</b-form>		
	</div>
</template>

<script>
// Organize imports
import { checkIfUserEmailExists } from '../../validator/checkIfUserEmailExists.js';
import { checkPasswordForValidity } from '../../validator/checkPasswordForValidity.js';

export default {
	data: function() {
		return {
			isUpdate: false,
			user: {
				firstname: '',
				lastname: '',
				email: '',
				password: '',
				role: 'user',
				active: true,
			},
			options: [
				{ value: 'user', text: 'Standardbenutzer' },
				{ value: 'support', text: 'Supportmitarbeiter' },
				{ value: 'admin', text: 'Administrator' },
				{ value: 'superadmin', text: 'Superadministrator' },
			],
			explanation: {
				user: "Der Standardbenutzer kann Anbieter, Gutscheine, Medien und Kunden verwalten. Er kann keine Systembenutzer anlegen oder verwalten.",
				admin: "Der Administrator kann Systembenutzer anlegen oder verwalten. Er kann keine Anbieter, Gutscheine, Medien oder Kunden verwalten.",
				support: "Der Supportmitarbeiter kann Kunden zum System hinzufügen. Die Rolle hat keine anderen Berechtigungen im System.",
				superadmin: "Der Superadministrator hat alle im System verfügbaren Berechtigungen und kann auf alle Bereiche zugreifen."
			},
			changePassword: false,
			userEmail: null,
		};
	},
	methods: {
		save: function() {
			this.$validator.validate().then(result => {
				if (!result) {
					// console.log("errors", this.$validator.errors);					
				} else {
					// Create a new data object
					var data = {							
							firstname: this.user.firstname,
							lastname: this.user.lastname,
							email: this.user.email,
							role: this.user.role,
							active: this.user.active,
					};
					
					if(this.isUpdate) {
						if(this.changePassword) {
							// When the user is updated and the password should be changed, add the password
							data.password = this.user.password;
						}
					} else {
						// When the user is created initially, add the password
						data.password = this.user.password;
					}
					
					// Send user to the server
					if(this.isUpdate) {
						// Update the user
		 				this.$http.put('users/updateByAdmin/' + this.updateId, data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();

							// If a user edited his own account, destroy the current session and redirect to login
              if(this.updateId == this.$auth.user()._id) {
                this.$auth.logout({
                  makeRequest: true,
                  redirect: '/login',
                });
              }
						}, response => {
							this.$emit('saveError', response);				
						});				
					} else {								
						// Save the user
						this.$http.post('users', data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();
						}, response => {
							this.$emit('saveError', response);				
						});
					}
				}
			});
		},
		loadUserForUpdate: function() {
			// Get user from server
			this.$http.get('users/' + this.updateId).then(user => {
				this.user = {
					firstname: user.body.firstname,
					lastname: user.body.lastname,
					email: user.body.email,
					role: user.body.role,
					active: user.body.active,
				};
				
				this.userEmail = user.body.email;
			}, response => {
				// console.log(response);
				this.users = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
		checkIfModeIsUpdate: function() {
			if(this.updateId !== null) {
				this.isUpdate = true;
				this.loadUserForUpdate();
			} else {
				this.isUpdate = false;
			}
		},
		clearPasswordFieldsContent: function() {
			this.user.password = '';
		},
	},
	watch: {
		updateId: function() {
			this.checkIfModeIsUpdate();
		},
		changePassword: function() {
			this.clearPasswordFieldsContent();
		},
	},
	created: function() {
		this.checkIfModeIsUpdate();
		this.$validator.localize('de');
		
		// Extend the validator
		this.$validator.extend('checkIfUserEmailExists', checkIfUserEmailExists);
		this.$validator.extend('checkPasswordForValidity', checkPasswordForValidity);
	},
	mounted: function() {
	},
	props: {
		formData: {
			required: true,
		},
		updateId: {
			default: null,
		}
	},
}
</script>

<style>
.form-container {
	padding: 5px;
}
.mb-3 {
	margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/07_user/UsersForm.vue